import { Typography } from "@mui/material";

import { formatDate } from "~/modules/app/util/formatters";

type TimelineDateLabelsProps = {
    firstStartDate: Date;
    latestEndDate: Date;
    firstStartDayIndex: number;
    latestEndDayIndex: number;
};

export function TimelineDateLabels({
    firstStartDate,
    latestEndDate,
    firstStartDayIndex,
    latestEndDayIndex,
}: TimelineDateLabelsProps) {
    return (
        <>
            {firstStartDayIndex !== -1 && (
                <Typography
                    variant="caption"
                    sx={theme => ({
                        gridColumn: `${firstStartDayIndex + 1} / span 1`,
                        gridRow: 3,
                        borderLeft: `1px solid ${theme.palette.divider}`,
                        padding: 0.5,
                        whiteSpace: "nowrap",
                    })}
                >
                    {formatDate(firstStartDate, "medium")}
                </Typography>
            )}

            {latestEndDayIndex !== -1 && latestEndDayIndex !== firstStartDayIndex && (
                <Typography
                    variant="caption"
                    sx={theme => ({
                        gridColumn: `1 / ${latestEndDayIndex + 1} `,
                        gridRow: 3,
                        borderRight: `1px solid ${theme.palette.divider}`,
                        padding: 0.5,
                        whiteSpace: "nowrap",
                        textAlign: "right",
                    })}
                >
                    {formatDate(latestEndDate, "medium")}
                </Typography>
            )}
        </>
    );
}
